var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRewards = function SvgRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "rewards_svg__Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".rewards_svg__st0{fill:#e33657}.rewards_svg__st1{fill:#ff4d4d}.rewards_svg__st2{fill:#fcb83f}.rewards_svg__st3{fill:#fdd937}.rewards_svg__st5{fill:#fa9647}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9.5c-3-1.9-8.5 1.7-9.9 6.5l5.3-1.8L25.6 7c1.3-2.6 1.1-5.4-.7-6.5",
    className: "rewards_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 5.3 15 7.1C13.6 2.3 8.1-1.4 5.1.6c-1.8 1.1-2 3.8-.7 6.5z",
    className: "rewards_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.4 22.1-5.3-.9-5.3.9v3.5l5.3.9 5.3-.9.9-1.8zM28.2 22.1l-5.3.9-5.3-.9-.9-4 .9-4 5.3-.9 5.3.9z",
    className: "rewards_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 22.1H1.8v-7.9l5.3-.9 5.3.9.9 4z",
    className: "rewards_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.2 25.6-5.3-.9-5.3.9-.9 2.2.9 2.2h10.6z",
    className: "rewards_svg__st2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 25.6H1.8V30h10.6l.9-2.2z",
    className: "rewards_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 4C22 2.7 17.4 4 15 7l5.3.9 5.3-.9c0-1.2-.5-2.3-1.5-3",
    style: {
      fill: "#ab3057"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 4c-1 .6-1.5 1.7-1.6 3l5.3.9 5.4-.8c-2.4-3-6.9-4.4-9.1-3.1",
    className: "rewards_svg__st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 22.1H17.6l-.9 1.8.9 1.8h10.6z",
    className: "rewards_svg__st5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m30 12.4-6.2.9-6.2-.9-.9-2.6.9-2.6H30z",
    className: "rewards_svg__st2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m12.4 12.4-6.2.9-6.2-.9V7.1h12.4l.9 2.6z",
    className: "rewards_svg__st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.4H17.6l-.9.9.9.9H30z",
    className: "rewards_svg__st5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 12.4H0v1.8h12.4l.9-.9z",
    className: "rewards_svg__st2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30h-2.6V7.1H15l.9 11.5z",
    className: "rewards_svg__st1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 30H15V7.1h2.6z",
    className: "rewards_svg__st0"
  })));
};
export default SvgRewards;